import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "./serviceWorkerRegistration";
import { initErrorMonitor } from "./utils/errorMonitor";
import { installConsentDefaults } from "./utils/consent";

// Google Consent Mode v2 defaults - WAZNE zeby bylo PRZED jakimkolwiek gtag.
installConsentDefaults();

// Centralny monitoring bledow - listenery window.onerror / unhandledrejection
initErrorMonitor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA Service Worker
registerServiceWorker();
